module.exports = __webpack_public_path__ + "static/media/background.avazanga.b2e32db2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/background.avazanga.png
// module id = 553
// module chunks = 0